// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShowMore_wrapper__1RVis","text":"ShowMore_text__2NRsd","showLess":"ShowMore_showLess__2eckP","textButton":"ShowMore_textButton__3LHtJ"};